import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './AutoplayVideo.css';

// Vertical (9:16) video that autoplays muted, loops, and has a tap-to-unmute / mute button on top.
// Props: src - video URL (e.g. `${process.env.PUBLIC_URL}/videos/message-from-ht.mp4`); empty shows a placeholder.
// Labels come from the 'unmute' and 'mute' keys in the messageFrom namespace.
function AutoplayVideo({ src }) {
  const { t } = useTranslation('messageFrom');
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  // Flip the sound on/off; the button label follows the state
  const toggleMute = () => {
    videoRef.current.muted = !muted;
    setMuted(!muted);
  };

  return (
    <div className="autoplayVideo">
      {src ? (
        <>
          {/* Browsers only allow autoplay when the video starts muted */}
          <video ref={videoRef} src={src} autoPlay muted loop playsInline />
          <button type="button" className="autoplayVideoBtn" onClick={toggleMute}>
            {muted ? t('unmute') : t('mute')}
          </button>
        </>
      ) : (
        <div className="autoplayVideoPlaceholder">▶</div>
      )}
    </div>
  );
}

export default AutoplayVideo;
